import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Image, Dropdown, Icon } from "semantic-ui-react";
import { scrollFunction } from "../functions/Functions";

import { data1 } from "./Data";
class Navbar extends Component {
  state = {
    openLeft: false,
  };

  //****************** */
  handleLoginModal = () => {
    this.props.openModal("LoginModal");
  };
  handleRegisterModal = () => {
    this.props.openModal("RegisterModal");
  };
  //^^^^^^^^^^^^^^^
  toggleDisplayLeft = () => {
    this.setState({ openLeft: !this.state.openLeft });
  };

  // @@@@@
  renderShowHideSidebarButtonLeft = () => {
    return this.state.openLeft === true ? (
      <>
        <div
          className="buttonSide"
          // style={{fontSize:'18px',height:'30px',color:'white'}}
          onClick={this.toggleDisplayLeft}
        >
          <Icon name="close" />
        </div>
      </>
    ) : (
      <>
        <button
          className="buttonSide"
          // style={{fontSize:'18px',height:'30px',color:'white'}}
          onClick={this.toggleDisplayLeft}
        >
          <Icon name="sidebar" />
        </button>
      </>
    );
  };
  //****************** */

  render() {
    //  NAV DESKTOP

    const authLinks = (
      <nav id="navbar-desktop"className="font-family-Roboto" style={{ flexDirection: "row" }}>
        <div style={{ display: "flex" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Image
              className=" border-logo box-shadow-1"
              size="small"
              src="/logo.png"
              style={{ marginRight: ".5em" }}
            />
            <div>
              {this.props.userA !== null &&
                (this.props.userA.userType === 'admin' || this.props.userA.userType === 'manager_dwk' || this.props.userA.userType === 'manager_ggn') &&
                this.renderShowHideSidebarButtonLeft()}

              <div
                className={
                  this.state.openLeft
                    ? "menu-left-wrapper menu-left-open "
                    : "menu-left-wrapper  "
                }
              >
                <div
                  onClick={this.toggleDisplayLeft}
                  style={{ width: "200px" }}
                  className="card font-16B color-white bgColor-CornflowerBlue flex-center border-radius-05"
                >
                  {/*  */}
                  <div className="dividerGr"></div>
                  <div
                    className="py-05"
                    onClick={() =>
                      this.props.openModal("CreateFormWebModal", {
                        award: true,
                      })
                    }
                  >
                    <span className="link-gr cursor-pointer">
                      Create Award
                    </span>
                  </div>

                  <div className="dividerGr"></div>

                  <div
                    className="py-05"
                    onClick={() =>
                      this.props.openModal("CreateFormWebModal", {
                        propOverview: true,
                      })
                    }
                  >
                    <span className="link-gr cursor-pointer" >
                      Create Prop Overview
                    </span>
                  </div>
                  <div className="dividerGr"></div>

                  {/* <div
                    className="py-05"
                    onClick={() =>
                      this.props.openModal("CreateFormWebModal", {
                        review: true,
                        btn: true,
                      })
                    }
                  >
                    <span className="link-gr cursor-pointer" >
                      Create Review
                    </span>
                  </div>
                  <div className="dividerGr"></div> */}
                  {this.props.userA !== null &&
                (this.props.userA.userType === 'admin' ) &&
                
                    <div
                    className="py-05"
                    
                  >
                    <span className="link-gr cursor-pointer" >
                    <Link className="link-gr" to="/UserList">
                    User List
                    </Link> 
                    </span>
                  </div>}
                  <div className="dividerGr"></div>
                </div>
              </div>
            </div>
            {/*  */}
          </div>
        </div>

        <ul>
          <br />

          <span>
            <li className="px-0 link-gr"
            onClick={()=>scrollFunction('home')}
            >
              {/* <a className="link-gr" href="#home">
                <Icon>
                  <i className="home icon"></i>
                </Icon>
              </a> */}
              <Icon>
                  <i className="home icon"></i>
                </Icon>
            </li>
          </span>
          <span></span>
          {data1.map((val) => {
           
            return (
              <div key={val.name}>
                <li className="px-0 link-gr"
                onClick={val.fn}
                >
                  {/* <a className="link-gr" href={val.link}>
                    {val.name}
                  </a> */}{val.name}
                </li>
              </div>
            );
          })}
          <span>
            <li
              className="px-0 link-gr"
              onClick={() => {
                const element = document.getElementById('contact');
                element?.scrollIntoView(); 
              }}
              // onClick={() => this.props.openModal("ContactUsModal")}
            >
              {/* <a className="link-gr" href="#contact">
                Contact Us
              </a> */} Contact Us
            </li>
          </span>
          <span>
            <li>
              <Dropdown
                style={{ color: "aqua", fontSize: "16px", fontWeight: "bold" }}
                pointing="top right"
                text="Properties"
                // icon="user outline"
              >
                <Dropdown.Menu>
                  {/*  */}

                  <Dropdown.Item
                    style={{
                      fontWeight: "bold",
                      cursor: "auto",
                      background:
                        "linear-gradient(to bottom right, #4a9cc5, #264982)",
                    }}
                  >
                    <Link className="link-gr" to="/dwk/">
                      Dwarka
                    </Link>
                  </Dropdown.Item>

                  <Dropdown.Item
                    style={{
                      fontWeight: "bold",
                      cursor: "auto",
                      background:
                        "linear-gradient(to bottom right, #4a9cc5, #264982)",
                    }}
                  >
                    <Link className="link-gr" to="/ggn/">
                      Dwarka Expressway
                    </Link>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </span>

          <span>
            <li className="px-0 link-gr">
              <Dropdown
                style={{ color: "aqua", fontSize: "16px", fontWeight: "bold" }}
                pointing="top right"
                icon="user outline"
              >
                <Dropdown.Menu>
                  {/*  */}

                  {!this.props.isAuthenticated && (
                    <Dropdown.Item
                      onClick={this.handleLoginModal}
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        background:
                          "linear-gradient(to bottom right, #4a9cc5, #264982)",
                      }}
                    >
                      <Icon name="power" />
                      Sign In
                    </Dropdown.Item>
                  )}
                  {this.props.isAuthenticated && (
                    <Dropdown.Item
                      onClick={this.props.onLogoutClick}
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        background:
                          "linear-gradient(to bottom right, #4a9cc5, #264982)",
                      }}
                    >
                      <Icon name="power" />
                      Sign Out
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </span>
        </ul>
      </nav>
    );

    return <div>{authLinks}</div>;
  }
}
//@@@@@@@@@@@@@@@@@

export default Navbar;
